import _ from 'underscore';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getStyles } from './styles';
import { SearchableDropdown } from './searchable-dropdown';

export function LanguageCountrySelection(props) {
  const {
    selectedLanguage,
    onLanguageSelected,
    languages,
    countryOptions,
    selectedCountry,
    onCountrySelected,
    isCountrySelectDisabled,
    error,
    noShadow,
  } = props;

  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getStyles, { noShadow });

  return (
    <div className={classNames('language-country-container', classes.languageCountryContainer)}>
      {countryOptions &&
        <div className={classNames('country-selection-container', classes.countryContainer)}>
          <SearchableDropdown
            className="country-dropdown"
            label={i18n.getString(_TL_('In which country is your business located?'))}
            selectedKey={selectedCountry}
            onChange={onCountrySelected}
            placeholder={i18n.getString(_TL_('Select country of your business location'))}
            options={countryOptions}
            disabled={isCountrySelectDisabled}
          />
        </div>
      }
      <div className={classNames('language-selection-container', classes.languageContainer)}>
        <SearchableDropdown
          className="language-dropdown"
          label={i18n.getString(_TL_('Which language do you want to advertise in?'))}
          selectedKey={selectedLanguage}
          onChange={onLanguageSelected}
          placeholder={i18n.getString(_TL_('Select a language'))}
          options={languages}
        />
      </div>
      {error && <p className={classNames('section-error', classes.error)}>{error}</p>}
    </div>
  );
}

LanguageCountrySelection.propTypes = {
  selectedLanguage: PropTypes.string,
  onLanguageSelected: PropTypes.func.isRequired,
  uiActivity: PropTypes.shape({
    trace: PropTypes.func,
  }).isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape({ key: PropTypes.string, text: PropTypes.string })),
  countryOptions: PropTypes.arrayOf(PropTypes.shape({ key: PropTypes.string, text: PropTypes.string })),
  selectedCountry: PropTypes.string,
  onCountrySelected: PropTypes.func,
  isCountrySelectDisabled: PropTypes.bool,
  error: PropTypes.string,
  noShadow: PropTypes.bool,
};

LanguageCountrySelection.defaultProps = {
  selectedLanguage: null,
  languages: [],
  countryOptions: null,
  selectedCountry: null,
  onCountrySelected: _.noop,
  isCountrySelectDisabled: false,
  error: '',
  noShadow: false,
};
